const products = [
  {
    id: 'vpn',
    tag: 'SECURITY',
    name: 'VPN Application',
    desc: 'Shield your online identity and encrypt your internet connection with military-grade protocols. Browse safely on any network, anywhere in the world.',
    highlights: ['256-bit AES Encryption', 'No-Log Policy', 'Global Server Network'],
    image: 'https://public.readdy.ai/ai/img_res/a2c94d40e95eb29be62013b766c0a353.jpg',
    dark: false,
  },
  {
    id: 'cleaner',
    tag: 'OPTIMIZATION',
    name: 'Cleaner Application',
    desc: 'Reclaim storage space and boost performance with smart junk detection and one-tap cleaning. Keep your iPhone running like new, every single day.',
    highlights: ['Smart Junk Detection', 'One-Tap Cleaning', 'Storage Analyzer'],
    image: 'https://readdy.ai/api/search-image?query=modern%20iOS%20phone%20cleaner%20optimization%20application%20on%20iPhone%20mockup%2C%20bright%20clean%20interface%20showing%20storage%20usage%20charts%20and%20cleaning%20progress%2C%20fresh%20white%20and%20light%20green%20color%20scheme%2C%20professional%20app%20showcase%20photography%20style%2C%20minimal%20background&width=560&height=400&seq=momas_cleaner_product_04&orientation=landscape',
    dark: false,
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="bg-white py-36">
      <div className="max-w-[1400px] mx-auto px-16">
        {/* Header */}
        <div className="flex items-end justify-between mb-20">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 rounded-full bg-[#D4FF00]" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8A8A8A]">Our Products</span>
            </div>
            <h2 className="text-[52px] font-bold text-[#1A1A1A] leading-[1.1]">
              Flagship iOS<br />
              <span className="italic font-light">Applications</span>
            </h2>
          </div>
          <p className="text-[#7A7A7A] text-lg leading-relaxed max-w-sm text-right">
            Explore our iOS applications designed to protect your privacy and
            optimize your device performance.
          </p>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="group rounded-2xl bg-[#F8F8F8] overflow-hidden border border-[#EFEFEF] hover:border-[#D4FF00] transition-all duration-300"
            >
              {/* Image */}
              <div className="w-full overflow-hidden" style={{ height: 280 }}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-8">
                <span className="inline-block bg-[#D4FF00] text-[#1A1A1A] text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-4">
                  {product.tag}
                </span>
                <h3 className="text-2xl font-bold text-[#1A1A1A] mb-3">{product.name}</h3>
                <p className="text-[#6A6A6A] text-sm leading-relaxed mb-6">{product.desc}</p>

                {/* Highlights */}
                <div className="flex flex-wrap gap-2">
                  {product.highlights.map((h) => (
                    <span
                      key={h}
                      className="inline-flex items-center gap-1.5 bg-white border border-[#E8E8E8] rounded-full px-3 py-1.5 text-xs text-[#4A4A4A] font-medium"
                    >
                      <i className="ri-check-line text-[#D4FF00] text-xs" />
                      {h}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dark accent block */}
        <div className="mt-8 rounded-2xl bg-[#0A0A0A] p-10 flex items-center justify-between">
          <div>
            <p className="text-[#D4FF00] text-xs font-bold tracking-widest uppercase mb-2">Available exclusively on</p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-apple-fill text-white text-2xl" />
              </div>
              <span className="text-white text-2xl font-bold">iOS Platform</span>
            </div>
          </div>
          <p className="text-white/50 text-sm max-w-xs text-right leading-relaxed">
            Crafted exclusively for iPhone and iPad users who demand the best in
            security and performance optimization.
          </p>
        </div>
      </div>
    </section>
  );
}
